import React, { useEffect, useMemo } from "react";
import {
  Popover,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  List,
  ListItem,
  Slider,
  ListItemText,
  Stack,
  FormControlLabel,
  Checkbox,
  Divider,
  Typography,
  Tooltip,
  Grid
} from "@mui/material";
import PropTypes from 'prop-types';
import _, { set } from "lodash";
import { gptUsageLimit, llmList } from "./constant";
import { getDefailtGpt5xVal, hasLowReasoningEffortFloor } from "../../../common/utils";


const PromptSettings = ({
  params,
  openSliderMenu,
  handleSliderMenuClose,
  anchorEl,
  isCustomized,
  isSentiment,
  isReviews,
  isPrompt,
}) => {
  const {
    selectedToneValue,
    setSelectedToneValue,
    selectedLengthValue,
    setSelectedLengthValue,
    llm,
    setLlm,
    cached, setCached,
    web_search, setWeb_search,
    api,
    setApi,
    presencePenalty = 0,
    setPresencePenalty,
    temperature,
    seed,
    setSeed,
    verbosity,
    setVerbosity,
    reasoning_effort,
    setReasoningEffort,
    setTemperature,
    frequencyPenalty = 0,
    setFrequencyPenalty,
    maxLength,
    setMaxLength,
    jsonResponseSchema,
    setJsonResponseSchema,
    jsonResponse,
    setJsonResponse,
    topP = 1,
    setTopP,
    customSettings,
    setCustomsettings,
    tabValue,
    reviewSelectionType,
    responseApi,
    setResponseApi,
    isTopPChecked, setIsTopPChecked,
    isTemperatureChecked, setIsTemperatureChecked,
  } = params;
  // const [isTopPChecked, setIsTopPChecked] = React.useState(true);
  // const [isTemperatureChecked, setIsTemperatureChecked] = React.useState(true);
  const handleToneChange = (event) => {
    setSelectedToneValue(event.target.value);
  };

  const handleLengthChange = (event) => {
    setSelectedLengthValue(event.target.value);
  };
  const ValueLabelComponent = (props) => {
    const { children, value } = props;
    return (
      <Tooltip enterTouchDelay={0} placement="top" title={value + 'k'}>
        {children}
      </Tooltip>
    );
  }
  ValueLabelComponent.propTypes = {
    children: PropTypes.element.isRequired,
    value: PropTypes.number.isRequired,
  };
  const minimalLabel = useMemo(()=>{
    return getDefailtGpt5xVal(llm)
  },[llm])
  
  // useEffect(()=>{
  //      if((llm==="gpt-5.1" || llm==="gpt-5.2")&& reasoning_effort==="medium"){
  //         setReasoningEffort('none')
  //      }else if(llm==="gpt-5-mini"){
  //         setReasoningEffort("minimal")
  //      }else{
  //         setReasoningEffort("medium");
  //      }
  
  //       if( (llm==="gpt-5.1" || llm==="gpt-5.2")){
  //         setReasoningEffort('none')
  //     }else if(llm==="gpt-5-mini"){
  //       setReasoningEffort("minimal")
  //     }
     
  //    },[llm])

  const handleLLMChange = (e) => {
    const selectedLLM = e.target.value;
    setLlm(selectedLLM);
      if(hasLowReasoningEffortFloor(selectedLLM)){
        setReasoningEffort('low')
    }else if((selectedLLM==="gpt-5.1" || selectedLLM==="gpt-5.2" || _.includes(selectedLLM, `gpt-5.4`) || _.includes(selectedLLM, `gpt-5.6`) || _.includes(selectedLLM, `gpt-6`))){
        setReasoningEffort('none')
    }else if(selectedLLM==="gpt-5-mini"){
      setReasoningEffort("minimal")
    }else{
      setReasoningEffort("medium");
    }
  }
     
  return (
    <Popover
      // slotProps={
      //   {
      //     paper: { sx: { width: '400px' } }
      //   }
      // }
      // id={sliderMenuId}
      open={openSliderMenu}
      anchorEl={anchorEl}
      onClose={handleSliderMenuClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
    >
      <div>
        <Box
          sx={{
            pt:
              isSentiment ||
                tabValue === 1 ||
                (isPrompt && reviewSelectionType !== "Multiple")
                ? 0
                : 3,
            px: 1,
          }}
        >
          {isCustomized && (
            <>
              {(isReviews ||
                (isPrompt && reviewSelectionType === "Multiple")) &&
                tabValue !== 1 && (
                  <>
                    <Divider sx={{ mb: 1 }}>
                      <Typography variant="caption">Custom Settings</Typography>
                    </Divider>
                    {isReviews && (
                      <Stack direction="row" spacing={2}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              size="small"
                              checked={customSettings.training}
                              onChange={(e) =>
                                setCustomsettings((prev) => ({
                                  ...prev,
                                  training: e.target.checked,
                                }))
                              }
                            />
                          }
                          label="Training Response"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              size="small"
                              checked={customSettings.facts}
                              onChange={(e) =>
                                setCustomsettings((prev) => ({
                                  ...prev,
                                  facts: e.target.checked,
                                }))
                              }
                            />
                          }
                          label="Facts"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              size="small"
                              checked={customSettings.brandVoice}
                              onChange={(e) =>
                                setCustomsettings((prev) => ({
                                  ...prev,
                                  brandVoice: e.target.checked,
                                }))
                              }
                            />
                          }
                          label="Voice"
                        />
                      </Stack>
                    )}
                    {isPrompt && reviewSelectionType === "Multiple" && (
                      <Stack direction="row" spacing={2}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              size="small"
                              checked={customSettings.executeParallel}
                              onChange={(e) =>
                                setCustomsettings((prev) => ({
                                  ...prev,
                                  executeParallel: e.target.checked,
                                }))
                              }
                            />
                          }
                          label="Execute Parallel"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              size="small"
                              checked={customSettings.singleReview}
                              onChange={(e) =>
                                setCustomsettings((prev) => ({
                                  ...prev,
                                  singleReview: e.target.checked,
                                }))
                              }
                            />
                          }
                          label="One Review at a time"
                        />
                      </Stack>
                    )}
                  </>
                )}
              <Divider sx={{ mb: 2, mt: 2 }}>
                <Typography variant="caption">LLM Settings</Typography>
              </Divider>
            </>
          )}
          <Grid container spacing={2} sx={{ mb: 2 }}>
            <Grid item xs={6}>
               <FormControl fullWidth>
            <InputLabel size="small">
              LLM
            </InputLabel>
            <Select
              size="small"
              label="LLM"
              value={llm}
              onChange={(e) => handleLLMChange(e)}
            >
              {_.map(llmList, llm => <MenuItem key={llm} value={llm}>{llm}</MenuItem>)}
            </Select>
          </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl variant="outlined" size="small" fullWidth>
                <InputLabel>API</InputLabel>
                <Select
                  label="API"
                  size="small"
                  value={api}
                  onChange={(e) => setApi(e.target.value)}
                >
                  <MenuItem value="completions">Completions</MenuItem>
                  <MenuItem value="responses">Responses</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
         
          {isCustomized && isReviews && tabValue !== 1 && (
            <FormControl fullWidth sx={{ mt: 2 }}>
              <InputLabel size="small">Word Length</InputLabel>
              <Select
                value={selectedLengthValue}
                onChange={handleLengthChange}
                fullWidth
                label="Word Length"
                size="small"
              >
                <MenuItem value={50}>50 Words</MenuItem>
                <MenuItem value={100}>100 Words</MenuItem>
                <MenuItem value={150}>150 Words</MenuItem>
              </Select>
            </FormControl>
          )}
        </Box>
         <div style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "16px",
          padding: '0px 16px'
        }}>
           <FormControl size="small" fullWidth sx={{marginTop:'16px'}}>
              <InputLabel>Verbosity</InputLabel>
              <Select value={verbosity} label='Verbosity' onChange={e => setVerbosity(e.target.value)} size="small" 
                disabled={!( _.includes(llm, 'gpt-5') || _.includes(llm, 'gpt-6') )}
                >
                <MenuItem value='low'>Low</MenuItem>
                <MenuItem value='medium'>Medium</MenuItem>
                <MenuItem value='high'>High</MenuItem>
              </Select>
            </FormControl>

            <FormControl size="small" fullWidth sx={{marginTop:'16px'}}>
              <InputLabel>Reasoning Effort</InputLabel>
              <Select value={reasoning_effort} label='Reasoning Effort' onChange={e => setReasoningEffort(e.target.value)}
                disabled={!( _.includes(llm, 'gpt-5') || _.includes(llm, 'gpt-6') )}
                sx={{textTransform:'capitalize'}}
                >
                {!hasLowReasoningEffortFloor(llm) && <MenuItem value={minimalLabel} sx={{textTransform:'capitalize'}}>{minimalLabel}</MenuItem>}
                <MenuItem value='low'>Low</MenuItem>
                <MenuItem value='medium'>Medium</MenuItem>
                <MenuItem value='high'>High</MenuItem>
              </Select>
            </FormControl>
            </div>
        <div style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "16px",
          padding: '0px 16px'
        }}>
          
          <List sx={{ width: '220px' }}>
            {isCustomized && isReviews && tabValue !== 1 && (
              <ListItem sx={{ px: 1 }}>
                <FormControl fullWidth>
                  <InputLabel size="small">Tone</InputLabel>
                  <Select
                    size="small"
                    value={selectedToneValue}
                    onChange={handleToneChange}
                    fullWidth
                    label="Voice"
                  >
                    <MenuItem value="Apologetic">Apologetic</MenuItem>
                    <MenuItem value="Funny">Funny</MenuItem>
                    <MenuItem value="Professional">Professional</MenuItem>
                  </Select>
                </FormControl>
              </ListItem>
            )}
            <ListItem>
              <Box sx={{display:'flex', alignItems:'center'}} >
                <FormControlLabel
                 control={<Checkbox checked={isTemperatureChecked} onChange={(e) => setIsTemperatureChecked(e.target.checked)} sx={{padding:'0 8px'}}/>}
                 label={`Temperature (${temperature})`}
              />
              </Box>
            </ListItem>
            <ListItem>
              <Slider
                value={temperature}
                size="small"
                min={0}
                max={1}
                step={0.01}
                onChange={(e, newValue) => setTemperature(newValue)}
                valueLabelDisplay="auto"
                disabled={!isTemperatureChecked}
              />
              {/* <FormControlLabel
                control={
                  <Checkbox
                    size="small"
                    checked={temperature}
                    onChange={(e) => setTemperature(e.target.checked)}
                  />
                }
                // labelPlacement="top"
                label="Temperature"
                pb={2}
              /> */}
            </ListItem>
            <ListItem>
              <ListItemText>Presence Penalty ({presencePenalty})</ListItemText>
            </ListItem>
            <ListItem>
              <Slider
                value={presencePenalty}
                size="small"
                min={0}
                max={2}
                step={0.01}
                onChange={(e, newValue) => setPresencePenalty(newValue)}
                valueLabelDisplay="auto"
              />
            </ListItem>
            <ListItem>
              <ListItemText>Max Input Length ({maxLength / 1000}k)</ListItemText>
            </ListItem>
            <ListItem>
              <Slider
                value={(maxLength / 1000)}
                // getAriaValueText={valuetext}
                size="small"
                min={0.5}
                slots={{
                  valueLabel: ValueLabelComponent,
                }}
                max={gptUsageLimit[llm]}
                step={0.5}
                onChange={(e, newValue) => setMaxLength(newValue * 1000)}
                valueLabelDisplay="auto"
              />
            </ListItem>
            {/* <ListItem>
              <ListItemText>Input Factor ({inputFactor + '%'})</ListItemText>
            </ListItem> */}
            {/* <ListItem>
              <Slider
                value={inputFactor}
                size="small"
                min={10}
                max={100}
                step={5}
                onChange={(e, newValue) => setInputFactor(newValue)}
                valueLabelDisplay="auto"
              />
            </ListItem> */}
            <ListItem sx={{ width: '220px' }}>
              {/* <Typography>Input Factor ({inputFactor + '%'})</Typography> */}
              <FormControlLabel
                control={
                  <Checkbox
                    size="small"
                    checked={jsonResponse}
                    onChange={(e) =>
                      setJsonResponse(e.target.checked)
                    }
                  />
                }
                // labelPlacement="top"
                label="Json Response"
              />
            </ListItem>
             <ListItem sx={{ width: '220px' }}>
              {/* <Typography>Input Factor ({inputFactor + '%'})</Typography> */}
              <FormControlLabel
                control={
                  <Checkbox
                    size="small"
                    checked={cached}
                    onChange={(e) =>
                      setCached(e.target.checked)
                    }
                  />
                }
                // labelPlacement="top"
                label="Cached"
              />
            </ListItem>
            {/* <ListItem sx={{ width: '220px' }}>
              <FormControlLabel
                control={
                  <Checkbox
                    size="small"
                    checked={responseApi}
                    onChange={(e) =>
                      setResponseApi(e.target.checked)
                    }
                  />
                }
                label="Response Api"
              />
            </ListItem> */}
          </List>
          <List sx={{ width: '220px' }}>
            <ListItem>
              
              <Box sx={{display:'flex', alignItems:'center'}} >
                <FormControlLabel
                 control = {<Checkbox checked={isTopPChecked} onChange={(e) => setIsTopPChecked(e.target.checked)} sx={{padding:'0 8px'}}/>}
                 label =  {`Top P (${topP})`}
                />
              </Box> 
              
            </ListItem>
            <ListItem>
              <Slider
                value={topP}
                size="small"
                min={0}
                max={1}
                step={0.1}
                onChange={(e, newValue) => setTopP(newValue)}
                valueLabelDisplay="auto"
                disabled={!isTopPChecked}
              />
              {/* <FormControlLabel
                control={
                  <Checkbox
                    size="small"
                    checked={topP}
                    onChange={(e) => setTopP(e.target.checked)}
                  />
                }
                // labelPlacement="top"
                label="Top P"
                pb={2}
              /> */}
            </ListItem>

            <ListItem>
              <ListItemText>Frequency Penalty ({frequencyPenalty})</ListItemText>
            </ListItem>
            <ListItem>
              <Slider
                value={frequencyPenalty}
                size="small"
                min={0}
                max={2}
                step={0.01}
                onChange={(e, newValue) => setFrequencyPenalty(newValue)}
                valueLabelDisplay="auto"
              />
            </ListItem>
            <ListItem>Seed</ListItem>
            <ListItem>
                    <Select value={seed} label='Seed' onChange={e=>setSeed(e.target.value)} size="small" fullWidth>
                      <MenuItem value='None'>None</MenuItem>
                      <MenuItem value='Fixed'>Fixed</MenuItem>
                      <MenuItem value='Random'>Random</MenuItem>
                      </Select>
            </ListItem>
            <ListItem sx={{ width: '250px' }}>
              {/* <Typography>Input Factor ({inputFactor + '%'})</Typography> */}
              <FormControlLabel
                control={
                  <Checkbox
                    size="small"
                    checked={jsonResponseSchema}
                    onChange={(e) =>
                      setJsonResponseSchema(e.target.checked)
                    }
                  />
                }
                // labelPlacement="top"
                label="Response Json Schema"
              />
            </ListItem>
            <ListItem sx={{ width: '250px' }}>

              <FormControlLabel
                control={
                  <Checkbox
                    size="small"
                    checked={web_search}
                    onChange={(e) => setWeb_search(e.target.checked)}
                  />
                }
                // labelPlacement="top"
                label="Website Research Tool"
              />

            </ListItem>
           
          
          </List>
          <List>


          </List>
        </div>
      </div>
    </Popover >
  );
};

export default PromptSettings;
